import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/api/hooks/useMutation';
import { socialConnectionsKeys } from '@/api/queryKeys';
import { ENV } from '@/config/env';

/**
 * Hook to handle Instagram OAuth callback.
 * Uses the Api container's settings client.
 */
export function useInstagramCallback() {
  const queryClient = useQueryClient();

  return useApiMutation({
    mutationFn: (api) => async (code: string) => {
      // redirectUri must exactly match the registered Meta app URI (no query params).
      await api.settings.settingsControllerPostAuthorization('INSTAGRAM', {
        code,
        redirectUri: ENV.instagram.redirectUri,
      });
    },
    onSuccess: () => {
      // Invalidate social connections to refetch with Instagram connection status
      queryClient.invalidateQueries({ queryKey: socialConnectionsKeys.list() });
    },
  });
}
